function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["components", "selectRef", "isLoading", "cacheUniqs"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// src/index.ts
import Select from "react-select"; // src/useAsyncPaginate.ts

import { useState as useState2, useCallback as useCallback2 } from "react"; // src/useAsyncPaginateBase.ts

import { useState, useEffect, useRef, useCallback } from "react";
import useIsMountedRef from "use-is-mounted-ref";
import { useLazyRef } from "@vtaits/use-lazy-ref"; // src/getInitialCache.ts

var getInitialCache = function getInitialCache(params) {
  return {
    isFirstLoad: true,
    options: [],
    hasMore: true,
    isLoading: false,
    additional: params.additional
  };
}; // src/getInitialOptionsCache.ts


var getInitialOptionsCache = function getInitialOptionsCache(_ref) {
  var options = _ref.options,
      defaultOptions = _ref.defaultOptions,
      additional = _ref.additional,
      defaultAdditional = _ref.defaultAdditional;
  var initialOptions = defaultOptions === true ? null : defaultOptions instanceof Array ? defaultOptions : options;

  if (initialOptions) {
    return {
      "": {
        isFirstLoad: false,
        isLoading: false,
        options: initialOptions,
        hasMore: true,
        additional: defaultAdditional || additional
      }
    };
  }

  return {};
}; // src/defaultShouldLoadMore.ts


var AVAILABLE_DELTA = 10;

var defaultShouldLoadMore = function defaultShouldLoadMore(scrollHeight, clientHeight, scrollTop) {
  var bottomBorder = scrollHeight - clientHeight - AVAILABLE_DELTA;
  return bottomBorder < scrollTop;
}; // src/defaultReduceOptions.ts


var defaultReduceOptions = function defaultReduceOptions(prevOptions, loadedOptions) {
  return [].concat(_toConsumableArray(prevOptions), _toConsumableArray(loadedOptions));
}; // src/requestOptions.ts


import sleep from "sleep-promise"; // src/validateResponse.ts

var errorText = '[react-select-async-paginate] response of "loadOptions" should be an object with "options" prop, which contains array of options.';

var checkIsResponse = function checkIsResponse(response) {
  if (!response) {
    return false;
  }

  var options = response.options,
      hasMore = response.hasMore;

  if (!Array.isArray(options)) {
    return false;
  }

  if (typeof hasMore !== "boolean" && typeof hasMore !== "undefined") {
    return false;
  }

  return true;
};

var validateResponse = function validateResponse(response) {
  if (!checkIsResponse(response)) {
    console.error(errorText, "Received:", response);
    throw new Error(errorText);
  }

  return true;
}; // src/requestOptions.ts


var requestOptions = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(caller, paramsRef, optionsCacheRef, debounceTimeout, setOptionsCache, reduceOptions) {
    var currentInputValue, isCacheEmpty, currentOptions, newInputValue, response, hasError, loadOptions, _response, options, hasMore, newAdditional;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            currentInputValue = paramsRef.current.inputValue;
            isCacheEmpty = !optionsCacheRef.current[currentInputValue];
            currentOptions = isCacheEmpty ? getInitialCache(paramsRef.current) : optionsCacheRef.current[currentInputValue];

            if (!(currentOptions.isLoading || !currentOptions.hasMore)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            setOptionsCache(function (prevOptionsCache) {
              return _objectSpread(_objectSpread({}, prevOptionsCache), {}, _defineProperty({}, currentInputValue, _objectSpread(_objectSpread({}, currentOptions), {}, {
                isLoading: true
              })));
            });

            if (!(debounceTimeout > 0 && caller === "input-change")) {
              _context.next = 13;
              break;
            }

            _context.next = 9;
            return sleep(debounceTimeout);

          case 9:
            newInputValue = paramsRef.current.inputValue;

            if (!(currentInputValue !== newInputValue)) {
              _context.next = 13;
              break;
            }

            setOptionsCache(function (prevOptionsCache) {
              if (isCacheEmpty) {
                var itemForDelete = prevOptionsCache[currentInputValue],
                    restCache = _objectWithoutProperties(prevOptionsCache, [currentInputValue].map(_toPropertyKey));

                return restCache;
              }

              return _objectSpread(_objectSpread({}, prevOptionsCache), {}, _defineProperty({}, currentInputValue, _objectSpread(_objectSpread({}, currentOptions), {}, {
                isLoading: false
              })));
            });
            return _context.abrupt("return");

          case 13:
            hasError = false;
            _context.prev = 14;
            loadOptions = paramsRef.current.loadOptions;
            _context.next = 18;
            return loadOptions(currentInputValue, currentOptions.options, currentOptions.additional);

          case 18:
            response = _context.sent;
            _context.next = 24;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](14);
            hasError = true;

          case 24:
            if (!hasError) {
              _context.next = 27;
              break;
            }

            setOptionsCache(function (prevOptionsCache) {
              return _objectSpread(_objectSpread({}, prevOptionsCache), {}, _defineProperty({}, currentInputValue, _objectSpread(_objectSpread({}, currentOptions), {}, {
                isLoading: false
              })));
            });
            return _context.abrupt("return");

          case 27:
            if (validateResponse(response)) {
              _response = response, options = _response.options, hasMore = _response.hasMore;
              newAdditional = response.hasOwnProperty("additional") ? response.additional : currentOptions.additional;
              setOptionsCache(function (prevOptionsCache) {
                return _objectSpread(_objectSpread({}, prevOptionsCache), {}, _defineProperty({}, currentInputValue, _objectSpread(_objectSpread({}, currentOptions), {}, {
                  options: reduceOptions(currentOptions.options, options, newAdditional),
                  hasMore: !!hasMore,
                  isLoading: false,
                  isFirstLoad: false,
                  additional: newAdditional
                })));
              });
            }

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 21]]);
  }));

  return function requestOptions(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}(); // src/useAsyncPaginateBase.ts


var increaseStateId = function increaseStateId(prevStateId) {
  return prevStateId + 1;
};

var useAsyncPaginateBase = function useAsyncPaginateBase(params) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var defaultOptions = params.defaultOptions,
      _params$loadOptionsOn = params.loadOptionsOnMenuOpen,
      loadOptionsOnMenuOpen = _params$loadOptionsOn === void 0 ? true : _params$loadOptionsOn,
      _params$debounceTimeo = params.debounceTimeout,
      debounceTimeout = _params$debounceTimeo === void 0 ? 0 : _params$debounceTimeo,
      inputValue = params.inputValue,
      menuIsOpen = params.menuIsOpen,
      _params$filterOption = params.filterOption,
      filterOption = _params$filterOption === void 0 ? null : _params$filterOption,
      _params$reduceOptions = params.reduceOptions,
      reduceOptions = _params$reduceOptions === void 0 ? defaultReduceOptions : _params$reduceOptions,
      _params$shouldLoadMor = params.shouldLoadMore,
      shouldLoadMore = _params$shouldLoadMor === void 0 ? defaultShouldLoadMore : _params$shouldLoadMor;
  var isMountedRef = useIsMountedRef();
  var isInitRef = useRef(true);
  var paramsRef = useRef(params);
  paramsRef.current = params;
  var setStateId = useState(0)[1];
  var optionsCacheRef = useLazyRef(function () {
    return getInitialOptionsCache(params);
  });
  var callRequestOptions = useCallback(function (caller) {
    requestOptions(caller, paramsRef, optionsCacheRef, debounceTimeout, function (reduceState) {
      optionsCacheRef.current = reduceState(optionsCacheRef.current);

      if (isMountedRef.current) {
        setStateId(increaseStateId);
      }
    }, reduceOptions);
  }, [debounceTimeout]);
  var handleScrolledToBottom = useCallback(function () {
    var currentInputValue = paramsRef.current.inputValue;
    var currentOptions2 = optionsCacheRef.current[currentInputValue];

    if (currentOptions2) {
      callRequestOptions("menu-scroll");
    }
  }, [callRequestOptions]);
  useEffect(function () {
    if (isInitRef.current) {
      isInitRef.current = false;
    } else {
      optionsCacheRef.current = {};
      setStateId(increaseStateId);
    }

    if (defaultOptions === true) {
      callRequestOptions("autoload");
    }
  }, deps);
  useEffect(function () {
    if (menuIsOpen && !optionsCacheRef.current[inputValue]) {
      callRequestOptions("input-change");
    }
  }, [inputValue]);
  useEffect(function () {
    if (menuIsOpen && !optionsCacheRef.current[""] && loadOptionsOnMenuOpen) {
      callRequestOptions("menu-toggle");
    }
  }, [menuIsOpen]);
  var currentOptions = optionsCacheRef.current[inputValue] || getInitialCache(params);
  return {
    handleScrolledToBottom: handleScrolledToBottom,
    shouldLoadMore: shouldLoadMore,
    filterOption: filterOption,
    isLoading: currentOptions.isLoading,
    isFirstLoad: currentOptions.isFirstLoad,
    options: currentOptions.options
  };
}; // src/useAsyncPaginate.ts


var useAsyncPaginate = function useAsyncPaginate(params) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var inputValueParam = params.inputValue,
      menuIsOpenParam = params.menuIsOpen,
      defaultInputValueParam = params.defaultInputValue,
      defaultMenuIsOpenParam = params.defaultMenuIsOpen,
      onInputChangeParam = params.onInputChange,
      onMenuCloseParam = params.onMenuClose,
      onMenuOpenParam = params.onMenuOpen;

  var _useState = useState2(defaultInputValueParam || ""),
      _useState2 = _slicedToArray(_useState, 2),
      inputValueState = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState2(!!defaultMenuIsOpenParam),
      _useState4 = _slicedToArray(_useState3, 2),
      menuIsOpenState = _useState4[0],
      setMenuIsOpen = _useState4[1];

  var inputValue = typeof inputValueParam === "string" ? inputValueParam : inputValueState;
  var menuIsOpen = typeof menuIsOpenParam === "boolean" ? menuIsOpenParam : menuIsOpenState;
  var onInputChange = useCallback2(function (nextInputValue, actionMeta) {
    if (onInputChangeParam) {
      onInputChangeParam(nextInputValue, actionMeta);
    }

    setInputValue(nextInputValue);
  }, [onInputChangeParam]);
  var onMenuClose = useCallback2(function () {
    if (onMenuCloseParam) {
      onMenuCloseParam();
    }

    setMenuIsOpen(false);
  }, [onMenuCloseParam]);
  var onMenuOpen = useCallback2(function () {
    if (onMenuOpenParam) {
      onMenuOpenParam();
    }

    setMenuIsOpen(true);
  }, [onMenuOpenParam]);
  var baseResult = useAsyncPaginateBase(_objectSpread(_objectSpread({}, params), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen
  }), deps);
  return _objectSpread(_objectSpread({}, baseResult), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen
  });
}; // src/useComponents.ts


import { useMemo } from "react";
import { components as defaultComponents } from "react-select"; // src/wrapMenuList.tsx

import { useEffect as useEffect2, useRef as useRef2, useCallback as useCallback3 } from "react";
import composeRefs from "@seznam/compose-react-refs";
import { jsx } from "react/jsx-runtime";
var CHECK_TIMEOUT = 300;

function wrapMenuList(MenuList2) {
  function WrappedMenuList(props) {
    var selectProps = props.selectProps,
        innerRef = props.innerRef;
    var handleScrolledToBottom = selectProps.handleScrolledToBottom,
        shouldLoadMore = selectProps.shouldLoadMore;
    var checkTimeoutRef = useRef2();
    var menuListRef = useRef2(null);
    var shouldHandle = useCallback3(function () {
      var el = menuListRef.current;

      if (!el) {
        return false;
      }

      var scrollTop = el.scrollTop,
          scrollHeight = el.scrollHeight,
          clientHeight = el.clientHeight;
      return shouldLoadMore(scrollHeight, clientHeight, scrollTop);
    }, [shouldLoadMore]);
    var checkAndHandle = useCallback3(function () {
      if (shouldHandle()) {
        if (handleScrolledToBottom) {
          handleScrolledToBottom();
        }
      }
    }, [shouldHandle, handleScrolledToBottom]);
    var setCheckAndHandleTimeout = useCallback3(function () {
      checkAndHandle();
      checkTimeoutRef.current = setTimeout(setCheckAndHandleTimeout, CHECK_TIMEOUT);
    }, [checkAndHandle]);
    useEffect2(function () {
      setCheckAndHandleTimeout();
      return function () {
        if (checkTimeoutRef.current) {
          clearTimeout(checkTimeoutRef.current);
        }
      };
    }, []);
    return /* @__PURE__ */jsx(MenuList2, _objectSpread(_objectSpread({}, props), {}, {
      innerRef: composeRefs(innerRef, menuListRef)
    }));
  }

  return WrappedMenuList;
} // src/useComponents.ts


var MenuList = wrapMenuList(defaultComponents.MenuList);

var useComponents = function useComponents(components) {
  return useMemo(function () {
    return _objectSpread({
      MenuList: MenuList
    }, components);
  }, [components]);
}; // src/withAsyncPaginate.tsx


import { jsx as jsx2 } from "react/jsx-runtime";
var defaultCacheUniqs = [];
var defaultComponents2 = {};

function withAsyncPaginate(SelectComponent) {
  function WithAsyncPaginate(props) {
    var _props$components = props.components,
        components = _props$components === void 0 ? defaultComponents2 : _props$components,
        _props$selectRef = props.selectRef,
        selectRef = _props$selectRef === void 0 ? void 0 : _props$selectRef,
        isLoadingProp = props.isLoading,
        _props$cacheUniqs = props.cacheUniqs,
        cacheUniqs = _props$cacheUniqs === void 0 ? defaultCacheUniqs : _props$cacheUniqs,
        rest = _objectWithoutProperties(props, _excluded);

    var asyncPaginateProps = useAsyncPaginate(rest, cacheUniqs);
    var processedComponents = useComponents(components);
    var isLoading = typeof isLoadingProp === "boolean" ? isLoadingProp : asyncPaginateProps.isLoading;
    return /* @__PURE__ */jsx2(SelectComponent, _objectSpread(_objectSpread(_objectSpread({}, props), asyncPaginateProps), {}, {
      isLoading: isLoading,
      components: processedComponents,
      ref: selectRef
    }));
  }

  return WithAsyncPaginate;
} // src/reduceGroupedOptions.ts


var checkGroup = function checkGroup(group) {
  if (!group) {
    return false;
  }

  var label = group.label,
      options = group.options;

  if (typeof label !== "string" && typeof label !== "undefined") {
    return false;
  }

  if (!Array.isArray(options)) {
    return false;
  }

  return true;
};

var reduceGroupedOptions = function reduceGroupedOptions(prevOptions, loadedOptions) {
  var res = prevOptions.slice();
  var mapLabelToIndex = {};
  var prevOptionsIndex = 0;
  var prevOptionsLength = prevOptions.length;
  loadedOptions.forEach(function (optionOrGroup) {
    var group = checkGroup(optionOrGroup) ? optionOrGroup : {
      options: [optionOrGroup]
    };
    var _group$label = group.label,
        label = _group$label === void 0 ? "" : _group$label;
    var groupIndex = mapLabelToIndex[label];

    if (typeof groupIndex !== "number") {
      for (; prevOptionsIndex < prevOptionsLength && typeof mapLabelToIndex[label] !== "number"; ++prevOptionsIndex) {
        var prevGroup = prevOptions[prevOptionsIndex];

        if (checkGroup(prevGroup)) {
          mapLabelToIndex[prevGroup.label || ""] = prevOptionsIndex;
        }
      }

      groupIndex = mapLabelToIndex[label];
    }

    if (typeof groupIndex !== "number") {
      mapLabelToIndex[label] = res.length;
      res.push(group);
      return;
    }

    res[groupIndex] = _objectSpread(_objectSpread({}, res[groupIndex]), {}, {
      options: [].concat(_toConsumableArray(res[groupIndex].options), _toConsumableArray(group.options))
    });
  });
  return res;
}; // src/index.ts


var AsyncPaginate = withAsyncPaginate(Select);
export { AsyncPaginate, checkIsResponse, reduceGroupedOptions, useAsyncPaginate, useAsyncPaginateBase, useComponents, validateResponse, withAsyncPaginate, wrapMenuList };